import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Heart } from 'lucide-react';
import { contactInfo } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="bg-black dark:bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img src="/logo.jpg" alt="Design Vision" className="w-8 h-8 rounded-lg object-cover" />
              <span className="font-display text-2xl font-bold tracking-tight">
                Design<span className="text-mid-purple">Vision</span>
              </span>
            </div>
            <p className="text-mid-grey text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sm uppercase tracking-wider">{t('footer.navigation')}</h4>
            <nav className="flex flex-col gap-2">
              <a href="/#services" className="text-mid-grey hover:text-white transition-colors text-sm">{t('nav.services')}</a>
              <a href="/#industries" className="text-mid-grey hover:text-white transition-colors text-sm">{t('nav.industries')}</a>
              <a href="/#reference" className="text-mid-grey hover:text-white transition-colors text-sm">{t('nav.reference')}</a>
              <a href="/#about" className="text-mid-grey hover:text-white transition-colors text-sm">{t('nav.about')}</a>
              <Link to="/faq" className="text-mid-grey hover:text-white transition-colors text-sm">{t('nav.faq')}</Link>
              <Link to="/blog" className="text-mid-grey hover:text-white transition-colors text-sm">{t('nav.blog')}</Link>
              <a href="/#contact" className="text-mid-grey hover:text-white transition-colors text-sm">{t('nav.contact')}</a>
            </nav>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sm uppercase tracking-wider">{t('footer.legal')}</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/impressum" className="text-mid-grey hover:text-white transition-colors text-sm">{t('footer.impressum')}</Link>
              <Link to="/datenschutz" className="text-mid-grey hover:text-white transition-colors text-sm">{t('footer.privacy')}</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sm uppercase tracking-wider">{t('nav.contact')}</h4>
            <div className="flex flex-col gap-3">
              <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2 text-mid-grey hover:text-white transition-colors text-sm">
                <Mail size={16} />
                {contactInfo.email}
              </a>
              <a href={`tel:${contactInfo.phone}`} className="flex items-center gap-2 text-mid-grey hover:text-white transition-colors text-sm">
                <Phone size={16} />
                {contactInfo.phone}
              </a>
              <div className="flex items-start gap-2 text-mid-grey text-sm">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-mid-grey text-sm">
            &copy; {currentYear} Design Vision. {t('footer.rights')}
          </p>
          <p className="text-mid-grey text-xs flex items-center gap-1">
            <Heart size={12} className="text-mid-pink" /> {t('footer.madeIn')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
